import React from 'react';
import styled from 'styled-components/native';
import {useTheme} from 'styled-components';
import {Theme} from '../../theme/lightTheme';
import {NewsOptionTab} from '../../utils/enums';
import {tr} from '../../translations';
import GenioLatestNews from '../genioLatestNews';
import Icon from '../icon';
import Animated, {FadeInDown, FadeOut} from 'react-native-reanimated';
import {SelectSummariesProps} from '../../interfaces/components/selectSummaries';
import {Platform} from 'react-native';
import '../../utils/webAnimations';

const Container = styled.View<{isVisible?: boolean}>`
  width: 100%;
  background-color: ${({theme}) => theme.quickAccess.background};
  border-radius: 22px;
  overflow: hidden;
  padding: ${({theme}) => theme.text.s12}px;
  ${({isVisible}) =>
    !isVisible &&
    `
    display:none;
   
    `}
`;
const OptionItem = styled(GenioLatestNews)`
  align-self: center;
  margin-bottom: ${({theme}) => theme.text.s12}px;
  width: 100%;
`;
const ContentContainer = styled.View`
  width: 100%;
`;
const Separator = styled.View`
  width: 100%;
  height: 1px;
  background-color: ${({theme}) => theme.border + '22'};
`;
const IconContainer = styled.View`
  height: 100%;
  aspect-ratio: 1;
  align-items: center;
  justify-content: center;
`;

const LIST = [
  NewsOptionTab.Summaries,
  NewsOptionTab.Analysis,
  NewsOptionTab.Predictions,
];

/**
 * SelectSummaries component.
 *
 * @param {SelectSummariesProps} props - The SelectSummaries component props.
 * @returns {React.ReactElement} The rendered SelectSummaries component.
 */
const SelectSummaries: React.FC<SelectSummariesProps> = ({
  style,
  onOptionTabPress,
  isVisible,
}: SelectSummariesProps): React.ReactElement => {
  const theme = useTheme() as Theme;

  const _renderItem = (item: NewsOptionTab, index: number) => {
    return (
      <Animated.View
        key={item}
        {...(Platform.OS === 'web'
          ? {className: 'screen-fade-in-down'}
          : {entering: FadeInDown.delay(index * 200), exiting: FadeOut})}>
        <Separator />
        <OptionItem
          title={tr(`latest.${item}`)}
          titleStyle={{
            fontSize: theme.text.s6,
            lineHeight: theme.text.s6 * 0.9,
          }}
          onPress={() => onOptionTabPress?.(item)}
          customLeftComponent={() => {
            return (
              <IconContainer>
                <Icon
                  name={item}
                  size={theme.text.s1 * 1.1}
                  color={theme.secondary}
                  stroke={theme.tertiary}
                />
              </IconContainer>
            );
          }}
        />
      </Animated.View>
    );
  };

  return (
    <Container isVisible={isVisible} style={style}>
      <ContentContainer>{LIST.map(_renderItem)}</ContentContainer>
    </Container>
  );
};

export default SelectSummaries;
